var _g, _path, _g2, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOver(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 -2 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_582_227)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9119 6.24464C12.005 4.54074 14.495 4.54074 15.588 6.24463L21.7642 15.8723C22.9502 17.7211 21.6227 20.15 19.4262 20.15H7.07382C4.87734 20.15 3.54979 17.7211 4.73577 15.8723L10.9119 6.24464Z",
    fill: "#4A6CF1"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7249 6.53621C11.9054 4.69601 14.5946 4.696 15.7751 6.53621L21.5447 15.5301C22.8256 17.5268 21.3918 20.15 19.0196 20.15H7.4804C5.1082 20.15 3.67444 17.5268 4.9553 15.5301L10.7249 6.53621Z",
    fill: "#4A6CF1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter1_f_582_227)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.988 5.51344C12.0957 3.95946 14.4043 3.95946 15.512 5.51344L21.3792 13.7449C22.6898 15.5837 21.3753 18.135 19.1172 18.135H7.3828C5.1247 18.135 3.81016 15.5837 5.12082 13.7449L10.988 5.51344Z",
    fill: "#4A6CF1"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M10.7249 3.93623C11.9054 2.09603 14.5946 2.09603 15.7751 3.93623L21.5447 12.9302C22.8256 14.9268 21.3918 17.55 19.0196 17.55H7.4804C5.1082 17.55 3.67444 14.9268 4.9553 12.9302L10.7249 3.93623Z",
    fill: "#4A6CF1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_582_227",
    x: 0.124837,
    y: 0.800008,
    width: 26.2503,
    height: 23.5167,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.08333,
    result: "effect1_foregroundBlur_582_227"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_582_227",
    x: 0.433431,
    y: 0.181233,
    width: 25.6331,
    height: 22.1204,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.08333,
    result: "effect1_foregroundBlur_582_227"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOver);
export default __webpack_public_path__ + "static/media/over.1296df89.svg";
export { ForwardRef as ReactComponent };